var accordion = function () {

    // Selectors object
    var selectors = {
        expanderToggles: document.querySelectorAll(".expander-toggle")
    };
    
    let listeners = function(){

        selectors.expanderToggles.forEach(expanderToggle => {
            expanderToggle.addEventListener("click", function (e){
                e.preventDefault();
                e.target.closest('.accordion').classList.toggle('is--active');

                selectors.expanderToggles.forEach(trigger => {
                    trigger.setAttribute('aria-expanded', 'false');
                    if(e.target.closest('.accordion') !== trigger.closest('.accordion')){
                        trigger.closest('.accordion').classList.remove('is--active');
                    }
                });
                
                if(e.target.closest('.accordion').classList.contains('is--active')) {
                    e.target.closest('.accordion').querySelector('.expander-toggle').setAttribute('aria-expanded', 'true');
                }
            })
        });
    }
    
    listeners();
}();
